import React, { useState, useEffect, useRef } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import HeadingArea from '../../general/HeadingArea';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import { FaPrint } from 'react-icons/fa';
import { GrUpdate } from "react-icons/gr";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";



const ExamReport = ({ setLoading }) => {
  const fileInputRef = useRef(null);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
const [isExistingAttendance, setIsExistingAttendance] = useState(false);
const [examData, setExamData] = useState(null);


  const [subjects, setSubjects] = useState([]);
  const [exam, setExam] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const [form, setForm] = useState({
    examType: '',
    class_name: '',
    section: '',
    year: '',
    subject: '',
    examMarks: '',
    total: '',

  })

  const [reportDetail, setReportDetail] = useState([]);
  const [assignedSubjects, setAssignedSubjects] = useState([]);
  const [obtainMark, setObtainMark] = useState({});

useEffect(() => {
  if (reportDetail.length > 0) {
    const initialMarks = {};
    reportDetail.forEach((item) => {
      initialMarks[item.id] = item.marks_obtain ?? '';
    });
    setObtainMark(initialMarks);
  }
}, [reportDetail]);


  useEffect(() => {

    fetchClasses();
    fetchAcademicYears();
    fetchSubjects();
    fetchExamTypeDetail();
    fetchAssignSubject();

  }, [])


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };



  const fetchSubjects = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-subjects');

      if (response.ok) {
        const data = await response.json();
        setSubjects(data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error('Failed to fetch class');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');

      if (response.ok) {
        const data = await response.json();
        setClasses(data);
        setLoading(false);


      } else {
        setLoading(false);
        console.error('Failed to fetch class');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  const fetchExamTypeDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.kcian.in/fetch-exam-type');
      setExam(res.data);

      setLoading(false);
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  };
  const fetchExamTypeDetailDebug = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.kcian.in/debug-attendance');
      // setExam(res.data);

      setLoading(false);
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'class_name') {
      const selectedClass = classes.find((cls) => cls.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        class_name: selectedClass
          ? { classId: selectedClass.id, className: selectedClass.class_name }
          : '',
      }));
    } else if (name === 'examType') {
      const selectedExam = exam.find((ex) => ex.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        examType: selectedExam
          ? { examTypeId: selectedExam.id, examTypeName: selectedExam.exam_name }
          : '',
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleSearch = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      const selectedExamType = exam.find((e) => e.id === Number(selectedExam));
      const examName = selectedExamType ? selectedExamType.exam_name : '';


      const selectedSubject = form.subject;
      const selectedSubjectName = subjects.find(
        (e) => String(e.id) === String(selectedSubject)
      );
      const subName = selectedSubjectName ? selectedSubjectName.sub_name : '';
  


      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);
      params.append('examType', examName);
      params.append('sub_name', subName);
    

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-exam-attendence?${params.toString()}`;
      // console.log('Request URL:', url);
      const response = await axios.get(url);

      if (response.data.length === 0) {
        // console.log('No data found')
        setResponse2({ message: 'No Exam Scheduled.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
        // console.log('data found....', response.data);
        setExamData(response.data[0]);
        const params = new URLSearchParams();
        params.append('ay', selectedAY);
        params.append('class_name', className);

        if (selectedSection) {
          params.append('section', selectedSection);
        }

let defaultAttendance = [];
           const attendanceResponse = await axios.get(`https://api.kcian.in/get-student-exam-attendance/${response.data[0].id}`);

          //  console.log(attendanceResponse);
    if (attendanceResponse.data && attendanceResponse.data.length) {
defaultAttendance = attendanceResponse.data;
    }
          setReportDetail(defaultAttendance);
          setIsExistingAttendance(true);
      }

    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


  const printRef = useRef();



  const fetchAssignSubject = async (classId = selectedClassId, section = selectedSection) => {

    if (!classId || !section) {
      // setResponse2({ message: 'Please select class and section before searching', status: 'error' });
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}&section=${section}`);

      const data = await res.json();
   
      if (res.ok) {
        if (data.length > 0) {
        

          setAssignedSubjects(data);
          setResponse2({ message: 'Assigned Subjects Fetched Successfully', status: 'success' });
        } else {
          setAssignedSubjects([])
          setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
        }
      } else {
        setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (error) {
      console.error('Fetch assigned subjects error:', error);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };



  const handleSubmit = async (id) => {
    const marks = obtainMark[id];


    try {
      const response = await axios.put(`https://api.kcian.in/update-exam-mark/${id}`, {
         obtainMarks: Number(marks),
      });

    
  
            setResponse2({
                message: 'Marks updated successfully !',
                status: 'success'
            });

            
            setTimeout(() => {
                setResponse2('');
            }, 2000);
    } catch (error) {
      console.error('Update failed:', error);
       setResponse2({ message: 'Fail to update marks.', status: 'error' });

            setTimeout(() => {
                setResponse2('');
            }, 2000);
            setLoading(false);
    }
  };


const handleDownload = () => {
  const excelData = reportDetail.map((data) => ({
    "Roll No": data.roll_no,
     "Student ID": data.student_id,
     "Exam Type":data.exam_type_id,
       "Year": data.year,
    "Registration No": data.reg_no,
    "Student Name": data.student_name,
    "Attendance":
      data.mark === "Present"
        ? "P"
        : data.mark === "Absent"
        ? "A"
        : "L",
    "Total Marks": examData.total_marks,
    "Obtained Marks": "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Exam Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob(
    [excelBuffer],
    {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }
  );

  saveAs(fileData, "Exam_Report.xlsx");
};


const fetchExamData = async () => {
  setLoading(true);

  try {
    const selectedClass = classes.find(
      (cls) => cls.id === Number(selectedClassId)
    );
    const className = selectedClass ? selectedClass.class_name : "";

    const selectedExamType = exam.find(
      (e) => e.id === Number(selectedExam)
    );
    const examName = selectedExamType ? selectedExamType.exam_name : "";

    const selectedSubjectName = subjects.find(
      (e) => String(e.id) === String(form.subject)
    );
    const subName = selectedSubjectName ? selectedSubjectName.sub_name : "";

    const params = new URLSearchParams();
    params.append("ay", selectedAY);
    params.append("class_name", className);
    params.append("examType", examName);
    params.append("sub_name", subName);

    if (selectedSection) {
      params.append("section", selectedSection);
    }

    const response = await axios.get(
      `https://api.kcian.in/get-exam-attendence?${params.toString()}`
    );

    if (response.data.length === 0) {
      setResponse2({ message: "No Exam Scheduled.", status: "error" });
      setTimeout(() => setResponse2(null), 2000);
      return;
    }

    setExamData(response.data[0]);

    const attendanceResponse = await axios.get(
      `https://api.kcian.in/get-student-exam-attendance/${response.data[0].id}`
    );

    setReportDetail(attendanceResponse.data || []);
    setIsExistingAttendance(true);
  } catch (error) {
    console.error("Error fetching students:", error);
  } finally {
    setLoading(false);
  }
};

const handleExcelUpload = async (event) => {
 

  const file = event.target.files[0];

  event.target.value = null;

  if (!file) return;

  const reader = new FileReader();

  reader.onload = async (e) => {
    try {
      const data = e.target.result;

      const workbook = XLSX.read(data, { type: "binary" });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });


      const payload = jsonData.map((row) => ({
        student_id: row["Student ID"],
        year: row["Year"],
        exam_type_id: row["Exam Type"],
        obtained_marks: row["Obtained Marks"],
      }));

     

      const res = await axios.put(
        "https://api.kcian.in/upload-exam-marks", 
        payload
      );

      if(res.status == 200){
         setResponse2({
                message: 'Marks updated successfully !',
                status: 'success'
            });

            
            setTimeout(() => {
                setResponse2('');
            }, 2000);

             fetchExamData();

} else if (res.status == 400){
       setResponse2({
                message:  'Fail to updated marks !',
                status: 'error'
            });

            
            setTimeout(() => {
                setResponse2('');
            }, 2000);

}
    } catch (err) {
      console.error(err);
         setResponse2({
                message: err.message || 'Fail to updated marks !',
                status: 'error'
            });

            
            setTimeout(() => {
                setResponse2('');
            }, 2000);
    }

  };

  reader.readAsBinaryString(file);
};



  return (
    <section className="px-4">
    <div className="py-4">
      <HeadingArea message1="Exam" message2="Exam Report" />

      <form onSubmit={handleSearch} className='profile-card'>
        <span className="profile-heading">Select Criteria</span>

        <div className='row mt-3'>

          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select AY*</label>
              <select
                className="profile-input"
                value={selectedAY}
                onChange={(e) => setSelectedAY(e.target.value)}
                required
              >
                <option value="">-- Select Academic Year --</option>
                {academicYears.map((ay) => (
                  <option key={ay.year} value={ay.year}>
                    {ay.year} --- {ay.title}
                  </option>
                ))}
              </select>
            </div>
          </div>


          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select Class*</label>
              <select
                className="profile-input"
                value={selectedClassId}
                onChange={(e) => setSelectedClassId(e.target.value)}
                required
              >
                <option value="">-- Select Class --</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.class_name}
                  </option>
                ))}
              </select>
            </div>
          </div>



          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select Section*</label>
            

              <select
                className="profile-input"
                value={selectedSection}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedSection(value);
                  fetchAssignSubject(selectedClassId, value); 
                }}
                disabled={availableSections.length === 0}
                required
              >
                <option value="">-- Select Section --</option>
                {availableSections.map((section, idx) => (
                  <option key={idx} value={section}>
                    {section}
                  </option>
                ))}
              </select>

            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area '>
              <label className='profile-badge'>Subject*</label>
              <select
                name='subject'
                value={form.subject}
                onChange={handleChange}
                className='profile-input'
                required
              >
                <option value=''>--- Select ---</option>
                {assignedSubjects.map((sub, index) => (
                  <option key={index} value={sub.sub_id}>
                    {sub.sub_name}
                  </option>
                ))}
              </select>
            </div>
          </div>


          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area '>
              <label className='profile-badge'>Exam Type*</label>
              <select
                className='profile-input'
                name='examType'
                value={selectedExam}
                onChange={(e) => setSelectedExam(e.target.value)}
                required
              >
                <option value=''>Select Type</option>
                {exam.map((type, index) => (
                  <option key={type.id} value={type.id}>
                    {type.exam_name}
                  </option>
                ))}
              </select>

            </div>
          </div>



        </div>
        {/* flex ends */}


            <div className="d-flex justify-content-end  gap-2 ">

         {examData !== null && examData !== undefined && (
  <>
    <button className='profile-btn2'   onClick={() => fileInputRef.current.click()}   >
      
      Upload
    </button>

    <input
  type="file"
  accept=".xlsx,.xls"
  ref={fileInputRef}
  style={{ display: "none" }}
  onChange={handleExcelUpload}
/>

    <button className='profile-btn2' onClick={handleDownload}>
      Download
    </button>
  </>
)}

          

        <div className='text-end'>
          <button type='submit' className='profile-btn2'>
            <AiOutlineSearch /> Search
          </button>
        </div>
  </div>

      </form>

   {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
      <div className='profile-card mt-3' ref={printRef} >


<span className="profile-heading">
  Student Exam Report 
  {examData && `- ${examData.average_marks} Passing Mark`}
</span>

    

        <p className='text-muted'>Present: P Absent: A Leave: L</p>
        <div className='table-responsive mb-3'>
          <table className='w-100'>
            <thead className='account-thead'>
              <tr>
                <th className="rounded-start-4">Roll No</th>
                <th>Admission No</th>
                <th>Reg No</th>
                <th>Name</th>
                <th>Status</th>
                <th>Total Marks</th>
                <th>Marks Obtain</th>
                <th>Result</th>
                <th className="rounded-end-4">Action</th>

              </tr>
            </thead>

            <tbody>
              {reportDetail.length === 0 ? (
                <tr className='text-center account-tr'>
                  <td colSpan="100%">No Student Data found</td>
                </tr>
              ) : (
              <>
               {reportDetail.map((data, index) => (
                  <tr key={index} className='account-tr'>
                    <td>{data.roll_no}</td>
                    <td>{data.admission_no}</td>
                    <td>{data.reg_no}</td>
                    <td>{data.student_name}</td>
<td>
  {data.mark == 'Present' ? 'P' : data.mark == 'Absent' ? 'A' : 'L'} {data.note && data.note.trim() !== '' ? `(${data.note})` : ''}
</td>

                    <td >{examData.total_marks}</td>

                    <td>
      
 <input
      type="number"
      className="profile-input border"
      style={{ width: '100px' }}
      value={obtainMark[data.id] || ''}
      onChange={(e) =>
        setObtainMark(prev => ({
          ...prev,
          [data.id]: e.target.value
        }))
      }
    />
                   
                    </td>
<td className={Number(data.marks_obtain) >= Number(examData.average_marks) ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
  {data.marks_obtain != null
    ? Number(data.marks_obtain) >= Number(examData.average_marks)
      ? 'Pass'
      : 'Fail'
    : '--'}
</td>

                    <td>
                      <button
                        className='profile-btn2'
                        onClick={() => handleSubmit(data.id)}
                      >
                        Update Mark
                      </button>   </td>


                  </tr>
                ))}
              </>
            )}
            </tbody>



          </table>
        </div>


      </div>

    </div>
    </section>
  )
}

export default ExamReport